import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText,
  FDHeadlineText,
} from '@facet-wealth/design';
import { Message } from './Components';

const titleProps = { size: 'lg' };

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: titleProps,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('message', { _component: () => Message }, overrideReadOnly);
